import { PromoAnalyticsService } from '@analytics/feature';
import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BannerWithButtonItem } from '@promo/const';
import { SdvorGenericLinkComponent } from '@sdvor/shared/ui';
import { NavigationButtonComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2/models';

@Component({
  selector: 'sd-banner-with-button-item',
  imports: [NavigationButtonComponent, NgOptimizedImage, SdvorGenericLinkComponent],
  templateUrl: './banner-with-button-item.component.html',
  styleUrls: ['./banner-with-button-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerWithButtonItemComponent {
  @Input() banner: BannerWithButtonItem;
  @Input() isDesktop: boolean;
  @Input() isTablet: boolean;

  iconTypes = IconTypes;

  constructor(private promoAnalyticsService: PromoAnalyticsService) {}

  protected onBannerClick(banner: BannerWithButtonItem): void {
    const { id, name } = banner;

    this.promoAnalyticsService.onClickBanner({
      id,
      name: name,
      position: 'main_page',
    });
  }
}
